import { FunctionComponent } from 'react';
import {
    Box,
    Card,
    CardContent,
    Stack,
    SvgIcon,
    Typography,
} from '@mui/material';
import { Mail } from '@/models/mail';
import IconButton from '@mui/material/IconButton';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { createBlobFromBase64encoded, downloadContentGeneric } from '@/utils';
import DownloadIcon from '@mui/icons-material/Download';

type MailDrawerContentProps = {
    mail: Mail;
    onClose: () => void;
};

export const MailDrawerContent: FunctionComponent<MailDrawerContentProps> = ({
    mail,
    onClose,
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100vh',
                width: '800px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    bgcolor: 'primary.dark',
                    color: '#fff',
                    p: 4,
                }}
            >
                <Typography variant='h6'>Mail-Details</Typography>

                <IconButton
                    onClick={onClose}
                    sx={{
                        ml: 'auto',
                    }}
                >
                    <SvgIcon
                        sx={{
                            color: '#fff',
                        }}
                        fontSize='medium'
                    >
                        <XMarkIcon />
                    </SvgIcon>
                </IconButton>
            </Box>

            <Stack
                sx={{
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                }}
                spacing={4}
            >
                <iframe
                    style={{
                        height: '100%',
                    }}
                    srcDoc={mail.html || ''}
                />

                {!!mail.attachments.length && (
                    <Box
                        sx={{
                            width: '100%',
                        }}
                    >
                        <Typography
                            sx={{
                                mb: 2,
                            }}
                            variant='h5'
                        >
                            Anhänge
                        </Typography>

                        {mail.attachments.map((attachement, index) => {
                            return (
                                <Card
                                    key={`attachment-${attachement.filename}-${index}`}
                                    onClick={() => {
                                        const blob =
                                            createBlobFromBase64encoded(
                                                attachement.data,
                                                attachement.contentType
                                            );
                                        downloadContentGeneric(
                                            attachement.filename,
                                            URL.createObjectURL(blob)
                                        );
                                    }}
                                    sx={{
                                        cursor: 'pointer',
                                        '&:hover': {
                                            bgcolor: '#eee',
                                        },
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <DownloadIcon
                                            sx={{ fontSize: '1.8rem' }}
                                        />
                                        <Typography
                                            sx={{
                                                ml: 2,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {attachement.filename}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            );
                        })}
                    </Box>
                )}
            </Stack>
        </Box>
    );
};
